var yy_request = require('../js/yunyin_request')

module.exports = {
  props: {
    fileList: Array,
  },

  data: function () {
    return {
      title: "请选择需要上传的文件",
      hasFileInput: true,
    }
  },

  methods: {
    removeFile: function(index) {
      var filedata = this.fileList

      if("id" in filedata[index]) {
        yy_request.rest_api({
          method: 'delete',
          api: 'file/'+filedata[index].id+'/',
          opSuccess: function(info) {
            filedata.$remove(index)
          },
          opFail: function(info) {
            filedata[index].info = "删除失败，请重试"
            filedata[index].status = "fail"
          },
        })
      } else {
        if('ajax_obj' in filedata[index]) {
          filedata[index].ajax_obj.XHR.abort()
        }
        filedata.$remove(index)
      }          
    },

    uploadFiles: function(e) {
      var input_files = this.$$.fileinput.files
     
      for(var i = 0;i<input_files.length;i++) {
        var ifile = input_files[i]
        var filedata = {
          fileobject: ifile,
          info: "上传中",
          status: "uploading",
        }

        this.fileList.push(filedata)
        uploadFile(filedata)

      }
      this.hasFileInput = false 
      this.hasFileInput = true //in case sometimes onChange Event will not be fired
    },

    reuploadFile: function(index) {
      var filedata = this.fileList[index]
      filedata.info = "上传中"
      filedata.status = "uploading"
      uploadFile(filedata)
    },

  },

  components: {
    'upload-file': require('./upload-file.vue')
  }
}

function uploadFile(filedata) {
  filedata.ajax_obj = yy_request.rest_api({
    method: 'post',
    api: 'file/token/',
    data: {
      name: filedata.fileobject.name
    },
    opSuccess: function(info) {
      filedata.token = info.token

      filedata.ajax_obj = yy_request.ajax({
        method: 'post',
        url: 'http://upload.qiniu.com/',
        data: {
          token: filedata.token,
          file: filedata.fileobject,
        },
        content: 'multipart',
        success: function(rs) {
          uploadConfirm(filedata,JSON.parse(rs).key)      
        },
        error: function(rs) {
          filedata.info = '上传失败'
          filedata.status = 'fail'
        },
      })
    },
    opFail: function(info) {
      filedata.info = info
      filedata.status = 'fail'      
    },
  })
}

function uploadConfirm(filedata,key) {
  filedata.ajax_obj = yy_request.rest_api({
    method: 'post',
    api: 'file/',
    data: {
      key: key,
    },
    opSuccess: function(info) {
      filedata.info = '上传成功'
      filedata.status = 'success'
      filedata.id = info.id
    },
    opFail: function(info) {
      filedata.info = info
      filedata.status = 'fail'
    },
  })
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/file-uploader.vue
// module id = 136
// module chunks = 0